module.exports = __webpack_public_path__ + "assets/img/gsyj.84e430b8.jpg";